import React from 'react';
import { format } from 'date-fns';
import * as Icon from 'react-feather';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card } from 'reactstrap';

import { useChatBotHistory } from '../../store/slices/dialSlice';

const ChatBot = () => {
  const { t } = useTranslation();
  const chatBotHistory = useChatBotHistory();
  return (
    <Container fluid className="chat-app">
      <Row className="h-100">
        {chatBotHistory?.length > 0 ? (
          <Col md="12" className="d-flex flex-column chat-bot-container">
            <div className="chat-app__header d-flex align-items-center">
              <span>
                <Icon.Headphones size={26} />
              </span>
              <strong className="text-capitalize ms-2 fs-5">Chat Bot</strong>
            </div>
            <div className="chat-app__messages flex-grow-1 p-3 overflow-auto">
              {chatBotHistory.map((msg, idx) => {
                const formattedTime = format(new Date(), 'hh:mm a');
                return (
                  <React.Fragment key={idx}>
                    {/* ANSWER → LEFT */}
                    {msg.answer && (
                      <div className="chat-app__message-wrapper sent">
                        <div className="chat-app__message">
                          <div className="chat-app__message-text">{msg.answer}</div>
                          <div className="chat-app__message-time">{formattedTime}</div>
                        </div>
                      </div>
                    )}
                    {/* QUESTION → RIGHT */}
                    {msg.question && (
                      <div className="chat-app__message-wrapper received">
                        <div className="chat-app__message">
                          <div className="chat-app__message-text">{msg.question}</div>
                          <div className="chat-app__message-time">{formattedTime}</div>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
            </div>
          </Col>
        ) : (
          <Col md="12">
            <Card className="p-0 d-flex justify-content-center align-items-center no-data m-0 h-100">
              {t('noMsgHereYet')}...
            </Card>
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default ChatBot;
